import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalService } from '@core/services/global/global.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-side-nav-carousel',
  standalone: true,
  imports: [],
  templateUrl: './side-nav-carousel.component.html',
  styleUrl: './side-nav-carousel.component.css',
})
export class SideNavCarouselComponent implements OnDestroy, OnInit {
  private readonly unsubscribe$ = new Subject<void>();
  public GroupName: string | null = null;
  currentIndex: number = 0;
  interval: any;

  constructor(private globalService: GlobalService) {}

  ngOnInit(): void {
    this.globalService.groupName$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((val) => {
        this.GroupName = val;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.complete();
  }

  startAutoScroll(): void {
    this.interval = setInterval(
      () => (this.currentIndex = (this.currentIndex + 1) % 2),
      2000,
    );
  }

  nextImage(): void {
    this.currentIndex = (this.currentIndex + 1) % 2;
  }

  goToImage(index: number): void {
    this.currentIndex = index;
  }
}
